import './SpikePatternScroller.css';

const ScrollPattern = () => {
    return(
        <div className="scroller"></div>
    );
}

export { ScrollPattern };